// ─── Planet / Question Bank ───────────────────────────────────────────────────
// Each planet has: id, name (Hebrew), emoji, gradient colours, glow RGB, questions[]
// Each question has: text (Hebrew), options[], correct (0-based index)
// Visual questions also have: visualPuzzle: { layout: 'row', elements: [{shape, color}] }
// Available shapes: triangle, square, circle, pentagon, hexagon, question-mark

export const PLANET_DATA = [
  {
    id: 0,
    name: 'כוכב החשיבה המילולית',
    emoji: '💬',
    gradFrom: '#0369a1',
    gradTo: '#38bdf8',
    glowRgb: '56,189,248',
    questions: [
      {
        text: "מצאי את הקשר: 'רוֹפֵא' קשור ל'מִרְפָּאָה' בדיוק כמו ש-:",
        options: ["'שְׁטִיחַ' קשור ל'רִצְפָּה'", "'שְׁפִיטָה' קשורה ל'עוֹנֶשׁ'", "'שּׁוֹפֵט' קשור ל'בֵּית מִשְׁפָּט'", "'מַחֲלָה' קשורה ל'תְּרוּפָה'"],
        correct: 2,
      },
      {
        text: 'איזו מילה יוצאת דופן בקבוצה?',
        options: ['כּוּרְסָא', 'סַפְסָל', 'כִּסֵּא', 'שָׁטִיחַ'],
        correct: 3,
      },
      {
        text: 'השלימי: הַיֶּלֶד הָיָה כָּל כָּךְ _____ עַד שֶׁהוּא בְּקֹשִׁי הִצְלִיחַ _____ אֶת עֵינָיו.',
        options: ['עָיֵף ; לִפְקֹחַ', 'רָעֵב ; לִסְגֹּר', 'שָׂמֵחַ ; לִרְאוֹת', 'עָיֵף ; לַעֲצֹם'],
        correct: 0,
      },
      {
        text: "מה הפירוש של המילה 'לְאַלְתֵּר'?",
        options: ['לכעוס מאוד', 'להמציא פתרון על המקום, ללא תכנון מראש', 'לוותר על משהו חשוב', 'לסדר את החדר'],
        correct: 1,
      },
      {
        text: "מצאי את הקשר: 'צָמֵא' קשור ל'מַיִם' בדיוק כמו ש'עָיֵף' קשור ל-:",
        options: ['מִטָּה', 'שֵׁינָה', 'חֲלוֹם', 'לַיְלָה'],
        correct: 1,
      },
      // ── Visual: AB colour alternation ──
      {
        text: 'הַצּוּרוֹת מִתְחַלְּפוֹת לְפִי חוֹק קָבוּעַ. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'circle', color: '#EF4444' },
            { shape: 'circle', color: '#3B82F6' },
            { shape: 'circle', color: '#EF4444' },
            { shape: 'circle', color: '#3B82F6' },
            { shape: 'circle', color: '#EF4444' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול כחול', 'עיגול אדום', 'ריבוע כחול', 'משולש אדום'],
        correct: 0,
      },
      // ── Visual: sides analogy (verbal analogy via shape properties) ──
      {
        text: 'הַצּוּרוֹת מִסְתַּדְּרוֹת לְפִי מִסְפַּר הַצְּלָעוֹת שֶׁלָּהֶן. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'triangle', color: '#F59E0B' },
            { shape: 'square',   color: '#F59E0B' },
            { shape: 'pentagon', color: '#F59E0B' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול', 'משולש', 'משושה', 'ריבוע'],
        correct: 2,
      },
    ],
  },
  {
    id: 1,
    name: 'תחנת החישובים',
    emoji: '🧮',
    gradFrom: '#86198f',
    gradTo: '#e879f9',
    glowRgb: '232,121,249',
    questions: [
      {
        text: 'רובוט הניווט מקבל סדרה: 1, 3, 6, 10, 15... מה יהיה המספר הבא?',
        options: ['18', '20', '21', '25'],
        correct: 2,
      },
      {
        text: '3 חֲתוּלֵי חָלָל תּוֹפְסִים 3 עַכְבְּרֵי חָלָל בְּ-3 דַּקּוֹת. כַּמָּה זְמַן יִקַּח לְחָתוּל אֶחָד לִתְפֹּס עַכְבַּר אֶחָד?',
        options: ['1 דקה', '3 דקות', '9 דקות', "אי אפשר לדעת"],
        correct: 1,
      },
      {
        text: 'בְּתֵיבַת הָאוֹצָר יֵשׁ 12 אֲבָנִים יְקָרוֹת. מַחֲצִית מֵהֶן אֲדֻמּוֹת. שְׁאָר הָאֲבָנִים הֵן כְּחֻלּוֹת וִירֻקּוֹת בְּכַמּוּת שָׁוָה. כַּמָּה אֲבָנִים כְּחֻלּוֹת יֵשׁ?',
        options: ['2', '3', '4', '6'],
        correct: 1,
      },
      {
        text: 'בְּגִינָּה יֵשׁ 4 שׁוּרוֹת שֶׁל עֵצִים, כָּל שׁוּרָה עִם 6 עֵצִים. אַחַר כָּךְ סוּפָה עָקְרָה 8 עֵצִים. כַּמָּה עֵצִים נִשְׁאֲרוּ?',
        options: ['14', '15', '16', '18'],
        correct: 2,
      },
      // ── Visual: AAB repeating group ──
      {
        text: 'הַצּוּרוֹת חוֹזְרוֹת לְפִי דְּפוּס קָבוּעַ. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'circle',   color: '#10B981' },
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול ירוק', 'משולש אדום', 'ריבוע כחול', 'משולש ירוק'],
        correct: 0,
      },
      // ── Visual: descending sides (6→5→4→3→circle) ──
      {
        text: 'בַּסִּדְרָה מִסְפַּר הַצְּלָעוֹת קָטֵן בְּ-1 בְּכָל פַּעַם. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'hexagon',  color: '#8B5CF6' },
            { shape: 'pentagon', color: '#8B5CF6' },
            { shape: 'square',   color: '#8B5CF6' },
            { shape: 'triangle', color: '#8B5CF6' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול', 'ריבוע', 'מחומש', 'משושה'],
        correct: 0,
      },
    ],
  },
  {
    id: 2,
    name: 'תחנת המשפטים השלמים',
    emoji: '📝',
    gradFrom: '#991b1b',
    gradTo: '#f87171',
    glowRgb: '248,113,113',
    questions: [
      {
        text: 'השלימי את החסר במשפט: שַׁחַר קָנָה בַּחֲנוּת ______ שֶׁל ______, מִפְּנֵי שֶׁהוּא מְאוֹד אוֹהֵב ______.',
        options: [
          'זֵר ; פְּרָחִים ; עֵצִים',
          'שַׂקִּית ; מַמְתַּקִּים ; מָתוֹק',
          'קֻפְסָה ; נַעֲלַיִם ; רִיצָה',
          'כּוֹס ; מַיִם ; צָמֵא',
        ],
        correct: 1,
      },
      {
        text: "מערכת התרגום של החללית שואלת: מה משמעות הביטוי 'טָמַן אֶת יָדוֹ בַּצַּלַּחַת'?",
        options: [
          'יָשַׁב לֶאֱכוֹל אֲרוּחָה',
          'הִתְעַצֵּל וְלֹא עָשָׂה דָּבָר',
          'עָזַר בְּנִקְיוֹן הַבַּיִת',
          'הֶחְבִּיא מַשֶּׁהוּ יְקַר עֵרֶךְ',
        ],
        correct: 1,
      },
      {
        text: 'השלימי את המשפט: הַיְּלָדִים יָצְאוּ לְשַׂחֵק בְּ_____ לַמְרוֹת שֶׁ_____ גֶּשֶׁם כָּבֵד.',
        options: [
          'כִּתָּה ; יָרַד',
          'חָצֵר ; שָׁתָה',
          'חָצֵר ; יָרַד',
          'בַּיִת ; טִפְטֵף',
        ],
        correct: 2,
      },
      {
        text: "מצאי את הקשר: 'מָחוֹג' קשור ל'שָׁעוֹן' כמו ש-'גַּלְגַּל' קשור ל-:",
        options: ['כְּבִישׁ', 'רֶכֶב', 'מֶרְחָק', 'הֶגֶה'],
        correct: 1,
      },
      // ── Visual: ABC colour cycle ──
      {
        text: 'הָעִגּוּלִים מִשְׁתַּנִּים לְפִי חוֹק צְבָעִים. מָה יִהְיֶה הָעִגּוּל הַבָּא?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'circle', color: '#EF4444' },
            { shape: 'circle', color: '#F59E0B' },
            { shape: 'circle', color: '#10B981' },
            { shape: 'circle', color: '#EF4444' },
            { shape: 'circle', color: '#F59E0B' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול ירוק', 'עיגול אדום', 'עיגול כחול', 'עיגול כתום'],
        correct: 0,
      },
      // ── Visual: ABAB shape+colour ──
      {
        text: 'שְׁתֵּי צוּרוֹת מִתְחַלְּפוֹת. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'square',   color: '#3B82F6' },
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'square',   color: '#3B82F6' },
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'square',   color: '#3B82F6' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['ריבוע כחול', 'משולש אדום', 'עיגול ירוק', 'משושה סגול'],
        correct: 1,
      },
    ],
  },
  {
    id: 3,
    name: 'ירח הצורות והחידות',
    emoji: '🔷',
    gradFrom: '#0e7490',
    gradTo: '#67e8f9',
    glowRgb: '103,232,249',
    questions: [
      {
        text: "בְּחַוַּת הֶחָלָל יֵשׁ חַיְזָרִים מִסּוּג 'זִיג' (עִם 2 רַגְלַיִם) וּמִסּוּג 'זָאג' (עִם 4 רַגְלַיִם). סַךְ הַכֹּל יֵשׁ 4 חַיְזָרִים, וְיֵשׁ לָהֶם בְּיַחַד 12 רַגְלַיִם. כַּמָּה חַיְזָרִים מִסּוּג 'זָאג' יֵשׁ?",
        options: ['1', '2', '3', '4'],
        correct: 1,
      },
      {
        text: 'לְפָנַיִךְ סִדְרָה שֶׁל צוּרוֹת מְרַחֲפוֹת. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה בַּסִּדְרָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'square',        color: '#10B981' },
            { shape: 'circle',        color: '#F59E0B' },
            { shape: 'circle',        color: '#F59E0B' },
            { shape: 'square',        color: '#10B981' },
            { shape: 'circle',        color: '#F59E0B' },
            { shape: 'circle',        color: '#F59E0B' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['משולש אדום', 'עיגול כתום', 'ריבוע ירוק', 'ריבוע כתום'],
        correct: 2,
      },
      {
        text: 'צָרִיךְ לְגַלּוֹת אֶת מִסְפַּר הַקֶּסֶם! תַּחֲנָה א׳: לְמַעְלָה 10, יָמִין 5, אֶמְצַע 15. תַּחֲנָה ב׳: לְמַעְלָה 8, יָמִין 4. מָה בָּאֶמְצַע שֶׁל תַּחֲנָה ב׳?',
        options: ['10', '12', '32', '4'],
        correct: 1,
      },
      {
        text: 'לְסַבָּא חָלָלִי יֵשׁ בַּגִּנָּה 3 עֵצִים שֶׁמַּצְמִיחִים כּוֹכָבִים. עַל כָּל עֵץ יֵשׁ 5 עֲנָפִים, וְעַל כָּל עָנָף בּוֹהֲקִים 2 כּוֹכָבִים. כַּמָּה כּוֹכָבִים יֵשׁ עַל כָּל הָעֵצִים יַחַד?',
        options: ['15', '10', '20', '30'],
        correct: 3,
      },
      // ── Visual: AABB repeating group ──
      {
        text: 'הַצּוּרוֹת מִתְחַלְּפוֹת בְּזוּגוֹת. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'circle',   color: '#F59E0B' },
            { shape: 'circle',   color: '#F59E0B' },
            { shape: 'pentagon', color: '#A855F7' },
            { shape: 'pentagon', color: '#A855F7' },
            { shape: 'circle',   color: '#F59E0B' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול כתום', 'מחומש סגול', 'ריבוע כחול', 'משולש ירוק'],
        correct: 0,
      },
      // ── Visual: mirror/colour flip ──
      {
        text: 'כָּל שְׁלוֹשָׁה צוּרוֹת יוֹצְרוֹת קְבוּצָה. מָה תַּשְׁלִים אֶת הַקְּבוּצָה הָאַחֲרוֹנָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'hexagon', color: '#EF4444' },
            { shape: 'hexagon', color: '#FFFFFF' },
            { shape: 'hexagon', color: '#EF4444' },
            { shape: 'square',  color: '#3B82F6' },
            { shape: 'square',  color: '#FFFFFF' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['ריבוע כחול', 'ריבוע לבן', 'משושה לבן', 'עיגול כחול'],
        correct: 0,
      },
    ],
  },
  {
    id: 4,
    name: 'כוכב הזהב',
    emoji: '⭐',
    gradFrom: '#92400e',
    gradTo: '#fcd34d',
    glowRgb: '252,211,77',
    questions: [
      {
        text: 'לדינה יש יותר ממה שיש ללין, וללין יש יותר ממה שיש לגל. מי מביניהן יש לה הכי פחות?',
        options: ['דינה', 'לין', 'גל', 'אי אפשר לדעת'],
        correct: 2,
      },
      {
        text: 'היום יום שלישי. מה היה לפני 3 ימים?',
        options: ['יום שישי', 'שבת', 'יום ראשון', 'יום חמישי'],
        correct: 1,
      },
      {
        text: 'מה המספר הבא בסדרה? 1, 4, 9, 16, ?',
        options: ['20', '25', '24', '30'],
        correct: 1,
      },
      {
        text: 'לכמה קודקודים (פינות) יש לקובייה?',
        options: ['6', '8', '12', '4'],
        correct: 1,
      },
      // ── Visual: colour-pair pattern ──
      {
        text: 'הַצּוּרוֹת מִתְחַלְּפוֹת בְּזוּגוֹת צְבָעִים. מָה תַּשְׁלִים אֶת הַסִּדְרָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'triangle', color: '#EF4444' },
            { shape: 'square',   color: '#EF4444' },
            { shape: 'triangle', color: '#3B82F6' },
            { shape: 'square',   color: '#3B82F6' },
            { shape: 'triangle', color: '#10B981' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['ריבוע ירוק', 'משולש ירוק', 'ריבוע כחול', 'עיגול ירוק'],
        correct: 0,
      },
      // ── Visual: two-property change (shape + colour both cycle) ──
      {
        text: 'שְׁנֵי דְּבָרִים מִשְׁתַּנִּים בְּיַחַד. מָה תִּהְיֶה הַצּוּרָה הַבָּאָה?',
        visualPuzzle: {
          layout: 'row',
          elements: [
            { shape: 'circle',   color: '#F59E0B' },
            { shape: 'square',   color: '#F59E0B' },
            { shape: 'circle',   color: '#A855F7' },
            { shape: 'square',   color: '#A855F7' },
            { shape: 'circle',   color: '#EF4444' },
            { shape: 'question-mark', color: '#FFFFFF' },
          ],
        },
        options: ['עיגול אדום', 'ריבוע סגול', 'ריבוע אדום', 'עיגול כתום'],
        correct: 2,
      },
    ],
  },
];

// Planet positions as % of the map container (cx = left%, cy = top%)
// They form a gentle arc from bottom-left to bottom-right through the top-center
export const PLANET_POSITIONS = [
  { cx: 13, cy: 70 },
  { cx: 29, cy: 43 },
  { cx: 50, cy: 23 },
  { cx: 71, cy: 43 },
  { cx: 87, cy: 70 },
];

// Catmull-Rom smooth SVG path through the five positions (viewBox "0 0 100 100")
// Control points computed analytically so the curve kisses each planet centre
export const MAP_PATH =
  'M 13,70 C 15.7,65.3 22,55 29,43 ' +
  'C 35,31 43.3,23 50,23 ' +
  'C 56.7,23 65,31 71,43 ' +
  'C 78,55 84.3,65.3 87,70';
